<template>
    <TsCard data-testid="home-new-launch-main" append-class="p-0 relative bg-white sm:h-full">
        <div class="absolute top-6 left-6 text-white">
            <TsTag
                append-class="text-sm bg-transparent border rounded-full font-semibold py-0.5 px-2.5 text-white mb-1.5"
                label="New" size="xs" rounded outlined />
            <TsTypography :variant="isMobile ? 'h2' : 'h1'" append-class="text-idle-white mb-4">Dewalt <br> <span
                    class="font-medium">Cordless Drill</span></TsTypography>

            <TsTypography :variant="isMobile ? 'base' : 'h2'" append-class="text-idle-white mb-4 sm:text-md"
                weight="bold">Play To <br> Experience <br> The <span class="text-[#DBAB4E]">Thrill</span>.
            </TsTypography>

            <div class="flex items-center space-x-2">
                <TsImage src="/images/logos/pause.svg" width="32" loading="lazy"/>
                <TsImage src="/images/logos/line.svg" width="128" height="6" loading="lazy"/>
            </div>

        </div>
        <TsImage
            :src="isMobile ? '/images/new-launch-dewalt-cordless.webp' : '/images/new-launch-dewalt-cordless-desktop.webp'"
            :width="isMobile ? '360' : '496'" :height="isMobile ? '303' : '380'" class="w-full sm:h-full" loading="lazy"/>
    </TsCard>
</template>

<script setup lang="ts">

const { isMobile } = useDevice();

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

</script>
